import React from 'react';
import {msAreaChartFusionChart,disposeChart} from 'util/fusionChartManager';
import {connect} from 'react-redux';

class App extends React.Component {
    predictNetworkId = "predict-network";
    predictHseId = "predict-hse";
    predictCustomerId = "predict-customer";
    predictServiceId = "predict-service";
    predictRepeatId = "predict-repeat";
    predictSecurityId = "predict-security";
    constructor(props) {
        super(props);

        this.props.showLoader();

        this.state = {
            isMobileView: false,

            // Setting initial values for partial loader state for all 6 six charts
            partialLoaderStatePredictNetwork: true,
            partialLoaderStatePredictHSE: true,
            partialLoaderStatePredictCustomer: true,
            partialLoaderStatePredictService: true,
            partialLoaderStatePredictRepeat: true,
            partialLoaderStatePredictSecurity: true,
        };
    }

    render() {

        this.dispatchActionToHideLoader();

        return (
            <div id="machine-learning" className="contentOuter-wrapper">
                <div>
                    <div className="page-heading d-sm-flex justify-content-sm-between align-items-sm-center">
                        <h1 className="mb-0">Machine Learning</h1>
                    </div>
                </div>
                <div>
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 ">
                            <div className="jr-card ">
                                <div className="jr-card-header">
                                    <h4>Predict Network Fault or Outage</h4>
                                </div>
                                <div className="jr-card-body">
                                    <div className="row mx-0">
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-8 px-0 m-0">
                                            <div id={this.predictNetworkId}/>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-4 px-0">
                                            <p className="first-line p-0 m-0">91% are correct</p>
                                            <p className="second-line p-0 m-0">955 are true positive</p>
                                            <p className="third-line p-0 m-0">20,071 are true negative</p>
                                            <div className="pt-2">
                                                <p className="first-line p-0 m-0">9% are errors</p>
                                                <p className="second-line p-0 m-0">431 false positive</p>
                                                <p className="third-line p-0 m-0">1,635 false negative</p>
                                            </div>
                                            <div className="pt-2">
                                                <p className="second-line p-0 m-0">6% of records predicted as
                                                    ”1”</p>
                                                <p className="third-line p-0 m-0">94% of records predicted as
                                                    “0”</p>
                                            </div>
                                            <button className="btn">
                                                RPA Trigger
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="jr-card ">
                                <div className="jr-card-header">
                                    <h4>Predict HSE Injury</h4>
                                </div>
                                <div className="jr-card-body ">
                                    <div className="row mx-0">
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-8 px-0 m-0">
                                            <div id={this.predictHseId}/>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-4 px-0">
                                            <p className="first-line p-0 m-0">91% are correct</p>
                                            <p className="second-line p-0 m-0">955 are true positive</p>
                                            <p className="third-line p-0 m-0">20,071 are true negative</p>
                                            <div className="pt-2">
                                                <p className="first-line p-0 m-0">9% are errors</p>
                                                <p className="second-line p-0 m-0">431 false positive</p>
                                                <p className="third-line p-0 m-0">1,635 false negative</p>
                                            </div>
                                            <div className="pt-2">
                                                <p className="second-line p-0 m-0">6% of records predicted as
                                                    ”1”</p>
                                                <p className="third-line p-0 m-0">94% of records predicted as
                                                    “0”</p>
                                            </div>
                                            <button className="btn">
                                                RPA Trigger
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="jr-card ">
                                <div className="jr-card-header">
                                    <h4>Predict Customer Experience (CSAT) Issue</h4>
                                </div>
                                <div className="jr-card-body ">
                                    <div className="row mx-0">
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-8 px-0 m-0">
                                            <div id={this.predictCustomerId}/>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-4 px-0">
                                            <p className="first-line p-0 m-0">91% are correct</p>
                                            <p className="second-line p-0 m-0">955 are true positive</p>
                                            <p className="third-line p-0 m-0">20,071 are true negative</p>
                                            <div className="pt-2">
                                                <p className="first-line p-0 m-0">9% are errors</p>
                                                <p className="second-line p-0 m-0">431 false positive</p>
                                                <p className="third-line p-0 m-0">1,635 false negative</p>
                                            </div>
                                            <div className="pt-2">
                                                <p className="second-line p-0 m-0">6% of records predicted as
                                                    ”1”</p>
                                                <p className="third-line p-0 m-0">94% of records predicted as
                                                    “0”</p>
                                            </div>
                                            <button className="btn">
                                                RPA Trigger
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                            <div className="jr-card ">
                                <div className="jr-card-header ">
                                    <h4>Predict Service Incident</h4>
                                </div>
                                <div className="jr-card-body ">
                                    <div className="row mx-0 ">
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-8 px-0 m-0">
                                            <div id={this.predictServiceId}/>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-4 px-0">
                                            <p className="first-line p-0 m-0">91% are correct</p>
                                            <p className="second-line p-0 m-0">955 are true positive</p>
                                            <p className="third-line p-0 m-0">20,071 are true negative</p>
                                            <div className="pt-2">
                                                <p className="first-line p-0 m-0">9% are errors</p>
                                                <p className="second-line p-0 m-0">431 false positive</p>
                                                <p className="third-line p-0 m-0">1,635 false negative</p>
                                            </div>
                                            <div className="pt-2">
                                                <p className="second-line p-0 m-0">6% of records predicted as
                                                    ”1”</p>
                                                <p className="third-line p-0 m-0">94% of records predicted as
                                                    “0”</p>
                                            </div>
                                            <button className="btn">
                                                RPA Trigger
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="jr-card ">
                                <div className="jr-card-header">
                                    <h4>Predict Repeat Truck Roll</h4>
                                </div>
                                <div className="jr-card-body ">
                                    <div className="row mx-0">
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-8 px-0 m-0">
                                            <div id={this.predictRepeatId}/>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-4 px-0">
                                            <p className="first-line p-0 m-0">91% are correct</p>
                                            <p className="second-line p-0 m-0">955 are true positive</p>
                                            <p className="third-line p-0 m-0">20,071 are true negative</p>
                                            <div className="pt-2">
                                                <p className="first-line p-0 m-0">9% are errors</p>
                                                <p className="second-line p-0 m-0">431 false positive</p>
                                                <p className="third-line p-0 m-0">1,635 false negative</p>
                                            </div>
                                            <div className="pt-2">
                                                <p className="second-line p-0 m-0">6% of records predicted as
                                                    ”1”</p>
                                                <p className="third-line p-0 m-0">94% of records predicted as
                                                    “0”</p>
                                            </div>
                                            <button className="btn">
                                                RPA Trigger
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="jr-card ">
                                <div className="jr-card-header">
                                    <h4>Predict Security Breach</h4>
                                </div>
                                <div className="jr-card-body ">
                                    <div className="row mx-0">
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-8 px-0 m-0">
                                            <div id={this.predictSecurityId}/>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-4 px-0">
                                            <p className="first-line p-0 m-0">91% are correct</p>
                                            <p className="second-line p-0 m-0">955 are true positive</p>
                                            <p className="third-line p-0 m-0">20,071 are true negative</p>
                                            <div className="pt-2">
                                                <p className="first-line p-0 m-0">9% are errors</p>
                                                <p className="second-line p-0 m-0">431 false positive</p>
                                                <p className="third-line p-0 m-0">1,635 false negative</p>
                                            </div>
                                            <div className="pt-2">
                                                <p className="second-line p-0 m-0">6% of records predicted as
                                                    ”1”</p>
                                                <p className="third-line p-0 m-0">94% of records predicted as
                                                    “0”</p>
                                            </div>
                                            <button className="btn">
                                                RPA Trigger
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    dispatchActionToHideLoader = () => {
        if (!this.state.partialLoaderStatePredictNetwork
            && !this.state.partialLoaderStatePredictHSE
            && !this.state.partialLoaderStatePredictCustomer
            && !this.state.partialLoaderStatePredictService
            && !this.state.partialLoaderStatePredictRepeat
            && !this.state.partialLoaderStatePredictSecurity) {
            this.props.hideLoader();
        }
    };

    componentDidMount = () => {

        const self = this;

        const categoriesPredictNetwork = [
            {
                category: [
                    {
                        label: 'Mon',
                    },
                    {
                        label: 'Tue',
                    },
                    {
                        label: 'Wed',
                    },
                    {
                        label: 'Thu',
                    },
                    {
                        label: 'Fri',
                    },
                    {
                        label: 'Sat',
                    },
                    {
                        label: 'Sun',
                    },
                    {
                        label: 'Mon',
                    },
                    {
                        label: 'Tue',
                    },
                    {
                        vline: 'true',
                        color: '#92d050',
                        thickness: '2',
                    },
                    {
                        label: 'Thu',
                    },
                    {
                        label: 'Fri',
                    },
                    {
                        label: 'Sat',
                    },
                    {
                        label: 'Sun',
                    },
                ],
            },
        ];

        const categoriesPredictHSE = [
            {
                category: [
                    {
                        label: 'Mon',
                    },
                    {
                        label: 'Tue',
                    },
                    {
                        label: 'Wed',
                    },
                    {
                        label: 'Thu',
                    },
                    {
                        label: 'Fri',
                    },
                    {
                        label: 'Sat',
                    },
                    {
                        label: 'Sun',
                    },
                    {
                        label: 'Mon',
                    },
                    {
                        vline: 'true',
                        color: '#92d050',
                        thickness: '2',
                    },
                    {
                        label: 'Tue',
                    },

                    {
                        label: 'Thu',
                    },
                    {
                        label: 'Fri',
                    },
                    {
                        label: 'Sat',
                    },
                    {
                        label: 'Sun',
                    },
                ],
            },
        ];

        const categoriesPredictCustomer = [
            {
                category: [
                    {
                        label: 'Mon',
                    },
                    {
                        label: 'Tue',
                    },
                    {
                        label: 'Wed',
                    },
                    {
                        vline: 'true',
                        color: '#92d050',
                        thickness: '2',
                    },
                    {
                        label: 'Thu',
                    },
                    {
                        label: 'Fri',
                    },
                    {
                        label: 'Sat',
                    },
                    {
                        label: 'Sun',
                    },
                    {
                        label: 'Mon',
                    },
                    {
                        label: 'Tue',
                    },

                    {
                        label: 'Thu',
                    },
                    {
                        label: 'Fri',
                    },
                    {
                        label: 'Sat',
                    },
                    {
                        label: 'Sun',
                    },
                ],
            },
        ];

        const categoriesPredictService = [
            {
                category: [
                    {
                        label: 'Mon',
                    },
                    {
                        label: 'Tue',
                    },
                    {
                        label: 'Wed',
                    },
                    {
                        label: 'Thu',
                    },
                    {
                        label: 'Fri',
                    },
                    {
                        label: 'Sat',
                    },
                    {
                        label: 'Sun',
                    },
                    {
                        label: 'Mon',
                    },
                    {
                        label: 'Tue',
                    },

                    {
                        label: 'Thu',
                    },
                    {
                        label: 'Fri',
                    },
                    {
                        vline: 'true',
                        color: '#92d050',
                        thickness: '2',
                    },
                    {
                        label: 'Sat',
                    },
                    {
                        label: 'Sun',
                    },
                ],
            },
        ];

        const categoriesPredictRepeat = [
            {
                category: [
                    {
                        label: 'Mon',
                    },
                    {
                        label: 'Tue',
                    },
                    {
                        label: 'Wed',
                    },
                    {
                        label: 'Thu',
                    },
                    {
                        label: 'Fri',
                    },
                    {
                        label: 'Sat',
                    },
                    {
                        vline: 'true',
                        color: '#92d050',
                        thickness: '2',
                    },
                    {
                        label: 'Sun',
                    },
                    {
                        label: 'Mon',
                    },
                    {
                        label: 'Tue',
                    },

                    {
                        label: 'Thu',
                    },
                    {
                        label: 'Fri',
                    },
                    {
                        label: 'Sat',
                    },
                    {
                        label: 'Sun',
                    },
                ],
            },
        ];

        const categoriesPredictSecurity = [
            {
                category: [
                    {
                        label: 'Mon',
                    },
                    {
                        label: 'Tue',
                    },
                    {
                        label: 'Wed',
                    },
                    {
                        label: 'Thu',
                    },
                    {
                        label: 'Fri',
                    },
                    {
                        label: 'Sat',
                    },
                    {
                        label: 'Sun',
                    },
                    {
                        label: 'Mon',
                    },
                    {
                        label: 'Tue',
                    },
                    {
                        vline: 'true',
                        color: '#92d050',
                        thickness: '2',
                    },
                    {
                        label: 'Thu',
                    },
                    {
                        label: 'Fri',
                    },
                    {
                        label: 'Sat',
                    },
                    {
                        label: 'Sun',
                    },
                ],
            },
        ];

        msAreaChartFusionChart('predict-network', categoriesPredictNetwork, '$dataset.2.set.8.centerx + 15', '$dataset.2.set.9.centerx + 55', '$dataset.2.set.8.centerx - 30', '0.7')
            .then(() => {
                self.setState({
                    partialLoaderStatePredictNetwork: false
                });
            });// 285
        msAreaChartFusionChart('predict-hse', categoriesPredictHSE, '$dataset.2.set.7.centerx + 15', '$dataset.2.set.8.endx + 55', '$dataset.2.set.7.centerx -30', '0.6')
            .then(() => {
                self.setState({
                    partialLoaderStatePredictHSE: false
                });
            }); // 257
        msAreaChartFusionChart('predict-customer', categoriesPredictCustomer, '$dataset.1.set.2.centerx + 15', '$dataset.1.set.3.endx + 55', '$dataset.1.set.2.centerx -30', '0.2')
            .then(() => {
                self.setState({
                    partialLoaderStatePredictCustomer: false
                });
            });
        msAreaChartFusionChart('predict-service', categoriesPredictService, '$dataset.2.set.10.centerx + 15', '$dataset.2.set.11.endx + 55', '$dataset.2.set.10.centerx -30', '0.9')
            .then(() => {
                self.setState({
                    partialLoaderStatePredictService: false
                });
            });
        msAreaChartFusionChart('predict-repeat', categoriesPredictRepeat, '$dataset.1.set.5.centerx + 15', '$dataset.1.set.6.endx + 55', '$dataset.1.set.5.centerx -30', '0.5')
            .then(() => {
                self.setState({
                    partialLoaderStatePredictRepeat: false
                });
            });
        msAreaChartFusionChart('predict-security', categoriesPredictSecurity, '$dataset.2.set.8.centerx + 15', '$dataset.2.set.9.endx + 55', '$dataset.2.set.8.centerx -30', '0.7')
            .then(() => {
                self.setState({
                    partialLoaderStatePredictSecurity: false
                });
            });
    };
    componentWillUnmount() {

        disposeChart(this.predictNetworkId);
        disposeChart(this.predictHseId);
        disposeChart(this.predictCustomerId);
        disposeChart(this.predictServiceId);
        disposeChart(this.predictRepeatId);
        disposeChart(this.predictSecurityId);

    }

}

const mapDispatchToProps = (dispatch) => {
    return {
        showLoader: () => {
            dispatch({type: 'SHOW_OVERALL_APP_LOADER'});
        },
        hideLoader: () => {
            dispatch({
                type: 'HIDE_OVERALL_APP_LOADER'
            });
        }
    }
};

export default connect(null, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./app/routes/machineLearning/index.js